import React, { useState, useEffect } from 'react';
import { Loading } from 'carbon-components-react';
import styled from 'styled-components';

// Components
import { Container, ContentContainer } from '../../components/Wrapper/Wrapper';
import LanguagesContent from './LanguagesContent';
import TileHeader from '../../components/TileHeader/TileHeader';
import NewLanguageModal from './NewLanguageModal';
import DeleteLanguageModal from './DeleteLanguageModal';
// api
// import { getAllLanguages } from '../../api/languages';

import { getLanguages } from '../../api/languages';
import ConfirmModal from '../../components/Modal/ConfirmModal';
import usePollReport from '../../hooks/usePollReport';
import { triggerReport } from '../../api/studyListApi';
import { toaster } from '../../helpers/toaster';

const Languages = ({
}) => {
	// loading is for initial component preloading
	const [loading, setLoading] = useState(true);

  const [languagesList, setLanguagesList] = useState(null);
  const [openNewLanguageModal, setOpenNewLanguageModal] = useState(false);
  const [openDeleteModal, setOpenDeleteModal] = useState(false);
  const [deleteItem, setDeleteItem] = useState(null);
  const [openLanguageModal, setOpenLanguageModal] = useState(false);
  const [detailModalMode, setDetailModalMode] = useState("create");
  const [language, setLanguage] = useState(null);

  const { startPolling, status: reportStatus } = usePollReport({
    onSuccess: () => { toaster('Languages report downloaded successfully', 'success'); },
    onError: () => toaster('Failed to generate report. Please try again.', 'error'),
  });

  const [openReportModal, setOpenReportModal] = useState(false);

  const handleGenerateReport = () => {
    setOpenReportModal(false);
    triggerReport('languages')
      .then(({ task_id }) => {
        toaster('Generating languages report...', 'info');
        startPolling(task_id);
      })
      .catch(() => toaster('Failed to start report generation.', 'error'));
  };

  const refreshLanguagesList = async () => {
    
    setLoading(true);
    let data = await getLanguages();
    setLanguagesList(data); 
    if(data){
      setLoading(false);
    }
  }
  const showDeleteConfirm = (itemId) => {
    setOpenDeleteModal(true);
    setDeleteItem(itemId);
  };

  const closeModal = () => {
    setOpenLanguageModal(false);
    setLanguage(null);
  };
  
  const addNewLanguage = () => {
    openLanguageModal(true);
  };

  useEffect(async () => {
    refreshLanguagesList();
  }, []);

  return (
    <Container>
      <ContentContainer>
        <TileHeader 
            title="Languages"
            subtitle="A list of all languages for attachments."
            size="lg"
        />

        
				

        <LanguagesContent
          languagesList={languagesList}
          setOpenNewLanguageModal={setOpenNewLanguageModal}
          onDeleteClicked={showDeleteConfirm}
          setOpenNewLanguageModal={setOpenLanguageModal}
          setDetailModalMode={setDetailModalMode}
          setLanguage={setLanguage}
          setMode={setDetailModalMode}
          onGenerateReport={() => setOpenReportModal(true)}
          reportStatus={reportStatus}
          />

        <NewLanguageModal
          open={openLanguageModal}
          languageData={language}
          refreshList={refreshLanguagesList}
          onClose={closeModal}
          mode={detailModalMode}
        />
        <ConfirmModal
          title="Generate Report"
          content="Do you want to generate the report? This may take awhile. Navigating away from this page will stop the report generation."
          open={openReportModal}
          onClose={() => setOpenReportModal(false)}
          onConfirm={handleGenerateReport}
        />
        <DeleteLanguageModal
          open={openDeleteModal}
          refreshList={refreshLanguagesList}
          onClose={() => setOpenDeleteModal(false)}
          languageList={languagesList}
          deleteItem={deleteItem}
        />
        
      </ContentContainer>
    </Container>
  );
};

export default Languages;